import SectionList from '../../components/sectionBoxes/SectionList';
import { FORMS } from '../../features/insurance/forms/consts';

const Form = () => {
  return (
    <div className="h-full flex flex-column">
      <div className="mt-6 mb-3 mx-8">
        <SectionList boxes={FORMS} />
      </div>
    </div>
  );
};

export default Form;
